import axios from 'axios'
import * as AuthInterceptor from './interceptor'

const axiosConfig = {
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
};

const axiosConfigFileUploads = {
  headers: {
    'Content-Type': 'multipart/form-data',
    'Accept': 'application/json',
  },
};

// Axios instance with interceptors
const $axios = axios.create(axiosConfig);
$axios.interceptors.request.use(AuthInterceptor.beforeRequestSuccess, AuthInterceptor.beforeRequestError);
$axios.interceptors.response.use(AuthInterceptor.onSuccess, AuthInterceptor.onError);

const $axiosFileUpload = axios.create(axiosConfigFileUploads);
$axiosFileUpload.interceptors.request.use(AuthInterceptor.beforeRequestSuccess, AuthInterceptor.beforeRequestError);
$axiosFileUpload.interceptors.response.use(AuthInterceptor.onSuccess, AuthInterceptor.onError);

const $axiosCustom = axios.create({});
$axiosCustom.interceptors.request.use(AuthInterceptor.beforeRequestSuccessCustom, AuthInterceptor.beforeRequestError);
$axiosCustom.interceptors.response.use(AuthInterceptor.onSuccess, AuthInterceptor.onError);

export { $axios, $axiosFileUpload, $axiosCustom }